export default __webpack_public_path__ + "static/media/m_engineering_card15_1.d2687008.png";